//const ajustesAPI = { url: "http://localhost/public/api/" }
//const ajustesAPI = { url: "http://192.168.1.13/public/api/" }
const ajustesAPI = { url: "https://api.censvictimesguerraifranquismepv.org/api/" }

export default ajustesAPI